__turbopack_context__.v({
  "btnAmber": "login-module-scss-module__xbh2Ka__btnAmber",
  "btnTeal": "login-module-scss-module__xbh2Ka__btnTeal",
  "card": "login-module-scss-module__xbh2Ka__card",
  "checkbox": "login-module-scss-module__xbh2Ka__checkbox",
  "checkboxLabel": "login-module-scss-module__xbh2Ka__checkboxLabel",
  "container": "login-module-scss-module__xbh2Ka__container",
  "divider": "login-module-scss-module__xbh2Ka__divider",
  "dividerText": "login-module-scss-module__xbh2Ka__dividerText",
  "errorBanner": "login-module-scss-module__xbh2Ka__errorBanner",
  "fieldGroup": "login-module-scss-module__xbh2Ka__fieldGroup",
  "forgotLink": "login-module-scss-module__xbh2Ka__forgotLink",
  "form": "login-module-scss-module__xbh2Ka__form",
  "input": "login-module-scss-module__xbh2Ka__input",
  "label": "login-module-scss-module__xbh2Ka__label",
  "linkAmber": "login-module-scss-module__xbh2Ka__linkAmber",
  "linkTeal": "login-module-scss-module__xbh2Ka__linkTeal",
  "logo": "login-module-scss-module__xbh2Ka__logo",
  "logoImg": "login-module-scss-module__xbh2Ka__logoImg",
  "registerLink": "login-module-scss-module__xbh2Ka__registerLink",
  "registerPrompt": "login-module-scss-module__xbh2Ka__registerPrompt",
  "row": "login-module-scss-module__xbh2Ka__row",
  "shimmer": "login-module-scss-module__xbh2Ka__shimmer",
  "socialBtn": "login-module-scss-module__xbh2Ka__socialBtn",
  "socialButtons": "login-module-scss-module__xbh2Ka__socialButtons",
  "socialIcon": "login-module-scss-module__xbh2Ka__socialIcon",
  "spin": "login-module-scss-module__xbh2Ka__spin",
  "spinner": "login-module-scss-module__xbh2Ka__spinner",
  "submitBtn": "login-module-scss-module__xbh2Ka__submitBtn",
  "subtitle": "login-module-scss-module__xbh2Ka__subtitle",
  "tab": "login-module-scss-module__xbh2Ka__tab",
  "tabActiveAmber": "login-module-scss-module__xbh2Ka__tabActiveAmber",
  "tabActiveTeal": "login-module-scss-module__xbh2Ka__tabActiveTeal",
  "tabs": "login-module-scss-module__xbh2Ka__tabs",
  "title": "login-module-scss-module__xbh2Ka__title",
});
